import React, { useState, useEffect } from "react";
import "./ModalItemSelecionado.css"; // Importe um arquivo CSS para os estilos
import TextArea from "antd/es/input/TextArea";

const ModalItemSelecionado = ({
  isVisible,
  onClose,
  onSave,
  produto,
  onDelete,
}) => {
  const [quantidade, setQuantidade] = useState(0);
  const [acrescimo, setAcrescimo] = useState(0);
  const [valorAcrescimo, setValorAcrescimo] = useState(0);
  const [desconto, setDesconto] = useState(0);
  const [valorDesconto, setValorDesconto] = useState(0);
  const [valorPreco, setValorPreco] = useState(0);
  const formatarPrecoInicial = (valor) => {
    const numero = Number(
      String(valor ?? 0).replace(',', '.')
    );

    if (Number.isNaN(numero)) {
      return '0,00';
    }

    return numero.toFixed(2).replace('.', ',');
  };
  const [preco, setPreco] = useState(
    produto
      ? formatarPrecoInicial(produto.preco)
      : '0,00'
  );
  const [isLoading, setIsLoading] = useState(true);
  const [observacao, setObservacao] = useState("");
  const [xPed_item, setXPedItem] = useState("");
  const [nItemPed, setNItemPed] = useState("");




  useEffect(() => {
    if (produto) {
      setQuantidade(produto.quantidade.toString());
      setAcrescimo(produto.acrescimo.toString());
      setDesconto(produto.desconto.toString());
      const precoFormatado =
        formatarPrecoInicial(produto.preco);

      setPreco(precoFormatado);

      setValorPreco(
        precoFormatado.replace(',', '.')
      );
      setValorAcrescimo(produto.valorAcrescimo.toString());
      setValorDesconto(produto.valorDesconto.toString());
      setObservacao(produto.observacao);
      setXPedItem(produto.xPed_item);
      setNItemPed(produto.nItemPed);
      console.log(produto);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
    }
  }, [produto, isVisible]);


  const handleSave = () => {
    console.log(preco);
    const valorSemSimbolo = preco.toString().replace(/[R$\s]/g, '');
    const valorComPonto = valorSemSimbolo.replace(',', '.');

    const updatedProduto = {
      ...produto,
      quantidade: parseFloat(quantidade),
      preco: parseFloat(valorComPonto),
      valorAcrescimo: valorAcrescimo,
      valorDesconto: valorDesconto,
      acrescimo: acrescimo,
      desconto: desconto,
      observacao: observacao,
      xPed_item: xPed_item,
      nItemPed: nItemPed
    };

    onSave(updatedProduto);
    onClose();
  };


  const handleDelete = () => {
    if (window.confirm(`Deseja excluir o item ${produto.nome}?`)) {
      onDelete(produto);
      onClose();
    }
  };

  const formatarValor = (text) => {
    const numericText = text.replace(/[^0-9]/g, "");

    if (!numericText) {
      setPreco("");
      return;
    }

    const formattedValue = `${numericText.slice(0, -2)},${numericText.slice(-2)}`;
    setPreco(formattedValue);
    setValorPreco(formattedValue.replace(",", "."));
  };

  if (!isVisible) return null;

  /*return (
    <div className="div-principal">
      <h2>Editar Produtoa</h2>
      <div className="modal-header">
        <button className="close-button" onClick={onClose}>Voltar</button>
        <h2>{produto.nome}</h2>
      </div>
      <div style={{ alignItems: 'center', textAlign: 'center' }}>
        
        <label className="titulo">Quantidade</label>
        <div className="input-group"   style={{width:'100%'}} >
          <button
            className="botoes-quantidade"
            onClick={() =>
              setQuantidade((prev) =>
                Math.max(1, parseInt(prev) - 1).toString()
              )
            }
          >
            -
          </button>
          <input
            type="number"
            className="input-estilizado"
            value={quantidade}
            onChange={(e) => setQuantidade(e.target.value)}
            style={{width:'83%'}}
          />
          <button
            className="botoes-quantidade"
            onClick={() =>
              setQuantidade((prev) => (parseInt(prev) + 1).toString())
            }
          >
            +
          </button>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <label className="titulo">Preço</label>
          <input
            className="input-estilizado"
            type="text"
            value={preco}

            onChange={(e) => formatarValor(e.target.value)}
          />
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label className="titulo">Desconto</label>
            <div className="input-group">
              <button
                className="botoes-quantidade"
                onClick={() => {

                  console.log((parseFloat(quantidade) *
                    parseFloat(valorPreco || 0) -
                    parseFloat(desconto || 0) +
                    parseFloat(valorAcrescimo || 0)));



                  console.log(parseFloat(quantidade) *
                    parseFloat(valorPreco || 0));


                  console.log(desconto);



                  if (
                    (parseFloat(quantidade) *
                      parseFloat(valorPreco || 0) -
                      parseFloat(desconto || 0) +
                      parseFloat(valorAcrescimo || 0)) > 0 && desconto >= 0
                  ) {
                    setValorDesconto(desconto);
                  }

                }
                }
              >
                ↓
              </button>
              <input
                className="input-estilizado"
                type="number"
                value={desconto}
                onChange={(e) => setDesconto(e.target.value)}
              />
              <button
                className="botoes-quantidade"
                onClick={() => {
                  if (desconto >= 0 && desconto <= 100) {
                    setValorDesconto(
                      (parseFloat(desconto) / 100) *
                      (parseFloat(preco) * parseFloat(quantidade)),
                    );
                  }
                }
                }
              >
                %
              </button>
            </div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <label className="titulo">Acréscimo</label>
            <div className="input-group">
              <button
                className="botoes-quantidade"
                onClick={() => {
                  setValorAcrescimo(acrescimo);
                }
                }
              >
                ↑
              </button>
              <input
                className="input-estilizado"
                type="number"
                value={acrescimo}
                onChange={(e) => setAcrescimo(e.target.value)}
              />

              <button
                className="botoes-quantidade"
                onClick={() => {
                  console.log(acrescimo);
                  console.log(acrescimo >= 0 && acrescimo <= 100);
                  if (acrescimo >= 0 && acrescimo <= 100) {
                    setValorAcrescimo(
                      (parseFloat(acrescimo) / 100) *
                      (
                        parseFloat(preco) * parseFloat(quantidade) -
                        parseFloat(valorDesconto)
                      ),
                    );
                  }
                }
                }
              >
                %
              </button>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
          <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}><label className="titulo">Número do Pedido de Compra</label>
            <input
              className="input-estilizado"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={15}
              value={xPed_item}
              onChange={(e) => {
                const v = e.target.value.replace(/\D/g, '').slice(0, 15);
                setXPedItem(v);
              }}
            />
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
            <label className="titulo">Item do Pedido de Compra</label>
            <input
              className="input-estilizado"
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={6}
              value={nItemPed}
              onChange={(e) => {
                const v = e.target.value.replace(/\D/g, '').slice(0, 6);
                setNItemPed(v);
              }}
            /></div>
        </div>

        <label className="titulo" style={{ fontSize: '24px' }}>Total</label>
        <input
          style={{ width: '100%' }}
          className="input-estilizado"
          type="text"
          value={`R$ ${(
            parseFloat(quantidade) *
            parseFloat(valorPreco || 0) -
            parseFloat(valorDesconto || 0) +
            parseFloat(valorAcrescimo || 0)
          ).toFixed(2)}`}
          readOnly
        />
      </div>

      <label className="titulo">Observações</label>
      <TextArea
        value={observacao}
        onChange={(e) => setObservacao(e.target.value)}
        maxLength={500}
        showCount
        rows={4}
        placeholder="Observações (máx. 500 caracteres)"
        style={{ marginTop: "10px", width: '50%' }}
      />

      <div className="button-container">

        <button onClick={handleDelete} className="excluir-button">
          Excluir Item <span className="trash-icon">🗑️</span>
        </button>


        <div className="action-buttons">
          <button onClick={onClose} className="cancel-button">
            Cancelar
          </button>
          <button onClick={handleSave} className="confirm-button">
            Confirmar
          </button>
        </div>
      </div>

    </div >

  );*/

  return (
    <div style={estiloPaginaEdicao}>
      <div style={estiloCardEdicao}>
        {/* Cabeçalho */}
        <div style={estiloCabecalhoEdicao}>
          <div>
            <h2 style={estiloTituloCabecalho}>
              Editar produto
            </h2>

            <span style={estiloSubtituloCabecalho}>
              {produto.nome}
            </span>
          </div>

          <button
            type="button"
            style={estiloBotaoPreto}
            onClick={onClose}
          >
            ← Voltar
          </button>
        </div>

        <div style={estiloFormulario}>
          {/* Três cards na mesma linha */}
          <div style={estiloGridPrincipal}>
            {/* Informações do item */}
            <div style={estiloSecao}>
              <h3 style={estiloTituloSecao}>
                📦 Informações do item
              </h3>

              <div style={estiloCampo}>
                <label style={estiloLabel}>
                  Quantidade
                </label>

                <div style={estiloGrupoInput}>
                  <button
                    type="button"
                    style={estiloBotaoInputEsquerdo}
                    onClick={() =>
                      setQuantidade((prev) =>
                        Math.max(
                          1,
                          parseInt(prev) - 1
                        ).toString()
                      )
                    }
                  >
                    −
                  </button>

                  <input
                    type="number"
                    value={quantidade}
                    onChange={(e) =>
                      setQuantidade(e.target.value)
                    }
                    style={estiloInputGrupo}
                  />

                  <button
                    type="button"
                    style={estiloBotaoInputDireito}
                    onClick={() =>
                      setQuantidade((prev) =>
                        (
                          parseInt(prev) + 1
                        ).toString()
                      )
                    }
                  >
                    +
                  </button>
                </div>
              </div>

              <div
                style={{
                  ...estiloCampo,
                  marginTop: '10px',
                }}
              >
                <label style={estiloLabel}>
                  Preço
                </label>

                <input
                  style={estiloInput}
                  type="text"
                  value={preco}
                  onChange={(e) =>
                    formatarValor(e.target.value)
                  }
                />
              </div>
            </div>

            {/* Ajustes de valor */}
            <div style={estiloSecao}>
              <h3 style={estiloTituloSecao}>
                💲 Ajustes de valor
              </h3>

              <div style={estiloCampo}>
                <label style={estiloLabel}>
                  Desconto
                </label>

                <div style={estiloGrupoInput}>
                  <button
                    type="button"
                    style={estiloBotaoInputEsquerdo}
                    title="Aplicar como valor"
                    onClick={() => {
                      console.log(
                        parseFloat(quantidade) *
                        parseFloat(valorPreco || 0) -
                        parseFloat(desconto || 0) +
                        parseFloat(valorAcrescimo || 0)
                      );

                      console.log(
                        parseFloat(quantidade) *
                        parseFloat(valorPreco || 0)
                      );

                      console.log(desconto);

                      if (
                        parseFloat(quantidade) *
                        parseFloat(valorPreco || 0) -
                        parseFloat(desconto || 0) +
                        parseFloat(valorAcrescimo || 0) >
                        0 &&
                        desconto >= 0
                      ) {
                        setValorDesconto(desconto);
                      }
                    }}
                  >
                    ↓
                  </button>

                  <input
                    style={estiloInputGrupo}
                    type="number"
                    value={desconto}
                    onChange={(e) =>
                      setDesconto(e.target.value)
                    }
                  />

                  <button
                    type="button"
                    style={estiloBotaoInputDireito}
                    title="Aplicar como porcentagem"
                    onClick={() => {
                      if (
                        desconto >= 0 &&
                        desconto <= 100
                      ) {
                        setValorDesconto(
                          (parseFloat(desconto) / 100) *
                          (
                            parseFloat(preco) *
                            parseFloat(quantidade)
                          )
                        );
                      }
                    }}
                  >
                    %
                  </button>
                </div>
              </div>

              <div
                style={{
                  ...estiloCampo,
                  marginTop: '10px',
                }}
              >
                <label style={estiloLabel}>
                  Acréscimo
                </label>

                <div style={estiloGrupoInput}>
                  <button
                    type="button"
                    style={estiloBotaoInputEsquerdo}
                    title="Aplicar como valor"
                    onClick={() => {
                      setValorAcrescimo(acrescimo);
                    }}
                  >
                    ↑
                  </button>

                  <input
                    style={estiloInputGrupo}
                    type="number"
                    value={acrescimo}
                    onChange={(e) =>
                      setAcrescimo(e.target.value)
                    }
                  />

                  <button
                    type="button"
                    style={estiloBotaoInputDireito}
                    title="Aplicar como porcentagem"
                    onClick={() => {
                      console.log(acrescimo);

                      console.log(
                        acrescimo >= 0 &&
                        acrescimo <= 100
                      );

                      if (
                        acrescimo >= 0 &&
                        acrescimo <= 100
                      ) {
                        setValorAcrescimo(
                          (parseFloat(acrescimo) / 100) *
                          (
                            parseFloat(preco) *
                            parseFloat(quantidade) -
                            parseFloat(valorDesconto)
                          )
                        );
                      }
                    }}
                  >
                    %
                  </button>
                </div>
              </div>
            </div>

            {/* Pedido de compra */}
            <div style={estiloSecao}>
              <h3 style={estiloTituloSecao}>
                🧾 Pedido de compra
              </h3>

              <div style={estiloCampo}>
                <label style={estiloLabel}>
                  Número do pedido
                </label>

                <input
                  style={estiloInput}
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={15}
                  value={xPed_item}
                  onChange={(e) => {
                    const v = e.target.value
                      .replace(/\D/g, '')
                      .slice(0, 15);

                    setXPedItem(v);
                  }}
                />
              </div>

              <div
                style={{
                  ...estiloCampo,
                  marginTop: '10px',
                }}
              >
                <label style={estiloLabel}>
                  Item do pedido
                </label>

                <input
                  style={estiloInput}
                  type="text"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={6}
                  value={nItemPed}
                  onChange={(e) => {
                    const v = e.target.value
                      .replace(/\D/g, '')
                      .slice(0, 6);

                    setNItemPed(v);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Total e observações */}
          <div style={estiloGridTotalObservacao}>
            <div style={estiloCardTotal}>
              <label style={estiloLabelTotal}>
                Total do item
              </label>
              <input
                style={estiloValorTotal}
                type="text"
                value={
                  (
                    parseFloat(quantidade || 0) *
                    parseFloat(valorPreco || 0) -
                    parseFloat(valorDesconto || 0) +
                    parseFloat(valorAcrescimo || 0)
                  ).toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                }
                readOnly
              />
            </div>

            <div style={estiloSecao}>
              <h3 style={estiloTituloSecao}>
                📝 Observações
              </h3>

              <TextArea
                value={observacao}
                onChange={(e) =>
                  setObservacao(e.target.value)
                }
                maxLength={500}
                showCount
                rows={2}
                placeholder="Observações (máx. 500 caracteres)"
                style={estiloObservacao}
              />
            </div>
          </div>

          {/* Rodapé */}
          <div style={estiloRodape}>
            <button
              type="button"
              onClick={handleDelete}
              style={estiloBotaoExcluir}
            >
              🗑️ Excluir item
            </button>

            <div style={estiloGrupoAcoes}>
              <button
                type="button"
                onClick={onClose}
                style={estiloBotaoCancelar}
              >
                Cancelar
              </button>

              <button
                type="button"
                onClick={handleSave}
                style={estiloBotaoPreto}
              >
                ✓ Confirmar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

};
const estiloPaginaEdicao = {
  width: '100%',
  padding: '12px',
  background: '#f4f6f9',
  boxSizing: 'border-box',
};

const estiloCardEdicao = {
  width: '100%',
  maxWidth: '1050px',
  margin: '0 auto',
  padding: '16px',
  background: '#ffffff',
  border: '1px solid #e5e7eb',
  borderRadius: '16px',
  boxShadow: '0 8px 24px rgba(15, 23, 42, 0.08)',
  boxSizing: 'border-box',
};

const estiloCabecalhoEdicao = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
  paddingBottom: '12px',
  marginBottom: '12px',
  borderBottom: '1px solid #e5e7eb',
};

const estiloTituloCabecalho = {
  margin: 0,
  color: '#111827',
  fontSize: '20px',
  fontWeight: '800',
};

const estiloSubtituloCabecalho = {
  display: 'block',
  marginTop: '2px',
  color: '#6b7280',
  fontSize: '13px',
};

const estiloFormulario = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
};

const estiloSecao = {
  padding: '12px',
  background: '#f8fafc',
  border: '1px solid #e5e7eb',
  borderRadius: '12px',
};

const estiloTituloSecao = {
  margin: '0 0 10px',
  color: '#374151',
  fontSize: '14px',
  fontWeight: '800',
};

const estiloGridDuasColunas = {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  gap: '10px',
};

const estiloGridPrincipal = {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: '10px',
  alignItems: 'stretch',
};

const estiloGridTotalObservacao = {
  display: 'grid',
  gridTemplateColumns: 'minmax(260px, 0.7fr) minmax(320px, 1.3fr)',
  gap: '10px',
  alignItems: 'stretch',
};

const estiloCampo = {
  display: 'flex',
  flexDirection: 'column',
  gap: '5px',
  minWidth: 0,
};

const estiloLabel = {
  color: '#374151',
  fontSize: '12px',
  fontWeight: '700',
  textAlign: 'left',
};

const estiloInput = {
  width: '100%',
  height: '40px',
  padding: '0 10px',
  background: '#ffffff',
  border: '1px solid #d1d5db',
  borderRadius: '9px',
  color: '#111827',
  fontSize: '14px',
  outline: 'none',
  boxSizing: 'border-box',
};

const estiloGrupoInput = {
  display: 'grid',
  gridTemplateColumns: '42px minmax(0, 1fr) 42px',
  width: '100%',
};

const estiloBotaoInputEsquerdo = {
  height: '40px',
  border: '1px solid #cbd5e1',
  borderRight: 'none',
  borderRadius: '9px 0 0 9px',
  background: '#eef2ff',
  color: '#312e81',
  fontSize: '17px',
  fontWeight: '800',
  cursor: 'pointer',
};

const estiloBotaoInputDireito = {
  height: '40px',
  border: '1px solid #cbd5e1',
  borderLeft: 'none',
  borderRadius: '0 9px 9px 0',
  background: '#eef2ff',
  color: '#312e81',
  fontSize: '15px',
  fontWeight: '800',
  cursor: 'pointer',
};

const estiloInputGrupo = {
  width: '100%',
  minWidth: 0,
  height: '40px',
  padding: '0 8px',
  border: '1px solid #cbd5e1',
  borderRadius: 0,
  background: '#ffffff',
  color: '#111827',
  fontSize: '14px',
  textAlign: 'center',
  outline: 'none',
  boxSizing: 'border-box',
};

const estiloCardTotal = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: '115px',
  padding: '14px 18px',
  background: 'linear-gradient(135deg, #18181b, #000000)',
  borderRadius: '12px',
  color: '#ffffff',
  boxShadow: '0 7px 18px rgba(0, 0, 0, 0.2)',
};

const estiloLabelTotal = {
  marginBottom: '4px',
  color: '#d1d5db',
  fontSize: '12px',
  fontWeight: '700',
  textTransform: 'uppercase',
};

const estiloValorTotal = {
  width: '100%',
  padding: 0,
  border: 'none',
  outline: 'none',
  background: 'transparent',
  color: '#ffffff',
  fontSize: '27px',
  fontWeight: '900',
};

const estiloObservacao = {
  width: '100%',
  minHeight: '80px',
  borderRadius: '9px',
  resize: 'vertical',
};

const estiloRodape = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '10px',
  paddingTop: '12px',
  marginTop: '2px',
  borderTop: '1px solid #e5e7eb',
};

const estiloGrupoAcoes = {
  display: 'flex',
  gap: '8px',
};

const estiloBotaoBase = {
  minHeight: '40px',
  padding: '8px 18px',
  borderRadius: '9px',
  fontSize: '14px',
  fontWeight: '800',
  cursor: 'pointer',
  transition: 'transform 0.15s ease, box-shadow 0.15s ease',
};

const estiloBotaoPreto = {
  ...estiloBotaoBase,
  border: '1px solid #000000',
  background: 'linear-gradient(135deg, #27272a, #000000)',
  color: '#ffffff',
  boxShadow: '0 5px 12px rgba(0, 0, 0, 0.22)',
};

const estiloBotaoCancelar = {
  ...estiloBotaoBase,
  border: '1px solid #d1d5db',
  background: '#ffffff',
  color: '#374151',
};

const estiloBotaoExcluir = {
  ...estiloBotaoBase,
  border: '1px solid #fecaca',
  background: '#fff1f2',
  color: '#dc2626',
};
export default ModalItemSelecionado;
